import { NewEventCustomer, UpdatedEventCustomer, NewEventFeedback, EventCustomer } from './event-customer.types';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class EventCustomerService {
	private eventCustomersUrl = (eventId: number) => `api/events/${eventId}/customers`;

	constructor(private _http: HttpClient) { }

	getEventCustomers(eventId: number): Promise<EventCustomer[]> {
		return this._http.get<EventCustomer[]>(this.eventCustomersUrl(eventId)).toPromise();
	}

	addEventCustomer(eventId: number, newCustomer: NewEventCustomer): Promise<number> {
		return this._http.patch<number>(this.eventCustomersUrl(eventId), newCustomer).toPromise();
	}

	addEventCustomers(eventId: number, newCustomers: NewEventCustomer[]): Promise<number> {
		return this._http.post<number>(this.eventCustomersUrl(eventId), newCustomers).toPromise();
	}

	updateEventCustomer(eventId: number, customerId: number, updatedCustomer: UpdatedEventCustomer): Promise<void> {
		return this._http.put<void>(`${this.eventCustomersUrl(eventId)}/${customerId}`, updatedCustomer).toPromise();
	}

	updateNotifyOnRsvp(eventId: number, notifyOnRsvp: boolean): Promise<void> {
		const options = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		return this._http.put<void>(`${this.eventCustomersUrl(eventId)}/me/notifyOnRsvp`, notifyOnRsvp, options).toPromise();
	}

	removeCustomer(eventId: number, eventCustomerId: number): Promise<void> {
		return this._http.delete<void>(`${this.eventCustomersUrl(eventId)}/${eventCustomerId}`).toPromise();
	}

	addCustomerEventFeedback(eventId: number, eventCustomerId: number, feedback: NewEventFeedback): Promise<void> {
		return this._http.post<void>(`${this.eventCustomersUrl(eventId)}/${eventCustomerId}/Feedback`, feedback).toPromise();
	}
}
